import styled from 'styled-components';
import { UserAvatarPlaceholder } from 'ui/illustrations';
import { Skeleton } from 'ui/skeleton';
import { colors, smallShadow, spacing } from 'ui/theme';

import { useUserMetadataQueryContext } from '../contexts/UserMetadataQueryContext';
import { GridArea } from './constants';

const Wrapper = styled.div`
  width: ${spacing.x10};
  height: ${spacing.x10};
  border-radius: ${spacing.x10};
  border: ${spacing.single} solid ${colors.grey15};
  background-color: ${colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  grid-area: ${GridArea.avatar};
  ${smallShadow}
`;

const LoadingPlaceholder = styled(Skeleton)`
  width: ${spacing.x7};
  height: ${spacing.x7};
  border-radius: ${spacing.x7};
  background-color: ${colors.grey5};
`;

export const Avatar = () => {
  const { isLoading } = useUserMetadataQueryContext();

  if (isLoading) {
    return (
      <Wrapper>
        <LoadingPlaceholder />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <UserAvatarPlaceholder />
    </Wrapper>
  );
};
